<template>
  <div>
    <CRow v-if="transactions.length">
      <CCol md="12">
        <CCard>
          <CCardBody>
            <CDataTable :striped="true" :items="transactions" :fields="fields" :loading="isLoad">
              <template #transaction_date="{ item }">
                <td>
                  {{ dateFormatter(item.transaction_date) }}
                </td>
              </template>
              <template #buyer_email="{ item }">
                <td>
                  {{ item.buyer_info.email }}
                </td>
              </template>
              <template #buyer_phone="{ item }">
                <td>
                  {{ item.buyer_info.phone }}
                </td>
              </template>
              <template #bank_name="{ item }">
                <td>
                  {{ item.buyer_info.bankName }}
                </td>
              </template>
              <template #bankholder_name="{ item }">
                <td>
                  {{ item.buyer_info.bankHolderName }}
                </td>
              </template>
              <template #bank_account_number="{ item }">
                <td>
                  {{ item.buyer_info.bankAccount }}
                </td>
              </template>
              <template #transferred_amount="{ item }">
                <td>
                  {{ item.buyer_info.amount }}
                </td>
              </template>
              <template #transfer_proof="{ item }">
                <td>
                  <img :src="item.transaction_proof" width="60" height="80" draggable="false" alt="Transfer Proof"
                    @click="onPreviewImage(0, item.transaction_proof)" />
                </td>
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <!-- Pagination -->
    <CPagination v-if="transactions.length" :activePage.sync="page" :double-arrows="false" :pages="getPage"
      @update:activePage="changePage" />
  </div>
</template>

<script>
import {
  TRANSACTION_GET,
} from '../../../constants/api'
import dateFormatter from '../../../utils/dateFormatter'
import moneyFormatter from '../../../utils/moneyFormatter'

import axios from 'axios'
import imagePreview from 'image-preview-vue'

export default {
  data() {
    return {
      dateFormatter,
      moneyFormatter,
      transactions: [],
      fields: [
        'order_id', 'transaction_date', 'buyer_email', 'buyer_phone', 'bank_name', 'bankholder_name', 'bank_account_number', 'transferred_amount', 'transfer_proof'
      ],
      page: 1,
      limit: 10,
      totalPage: 1,
      isLoad: false,
      image: '',
      accessToken: sessionStorage.getItem('access_token') || '',
    }
  },

  beforeMount() {
    const payload = {
      start: 0
    }
    this.fetchTransaction(payload)
  },

  computed: {
    getPage() {
      return Math.ceil(this.totalPage / this.limit)
    },
  },

  methods: {
    fetchTransaction(payload) {
      this.isLoad = true

      axios.get(TRANSACTION_GET, {
        headers: {
          'x-access-token': this.accessToken
        },
        params: payload
      })
        .then(res => {
          this.transactions = res.data.data
          this.limit = res.data.limitNum
          this.totalPage = res.data.totalCount
          this.isLoad = false
        })
    },

    changePage(pageNumber) {
      const payload = {
        start: (pageNumber - 1) * this.limit
      }

      this.fetchTransaction(payload)
    },

    onPreviewImage(index, images) {
      imagePreview({
        zIndex: 99999,
        initIndex: index,
        images: [images],
        onClose: () => { }
      })
    }
  }
}
</script>